// extracted by mini-css-extract-plugin
module.exports = {"container":"DTRSummaryList_container__1aKaB"};